<template>
  <button
    type="button"
    class="header__trigger"
    :title="$t(title)"
    @click="toggle()"
  >
    {{ $t(title) }}
  </button>
</template>

<script lang="ts" setup>
import { computed, ref, watchEffect } from "vue";

const isOpen = ref(false);

const toggle = () => (isOpen.value = !isOpen.value);

const title = computed(() =>
  isOpen.value ? "common.closeMenu" : "common.openMenu",
);

watchEffect(() => {
  if (isOpen.value) {
    document.documentElement.classList.add("is-header-open");
  } else {
    document.documentElement.classList.remove("is-header-open");
  }
});
</script>
